import React, {useEffect, useState} from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Logo from './Logo';

const {FiArrowUpRight, FiMenu, FiX} = FiIcons;

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const goToServices = () => {
    setOpen(false);
    if (location.pathname === '/home') {
      document.getElementById('services')?.scrollIntoView({behavior: 'smooth'});
    } else {
      navigate('/home');
      window.setTimeout(() => document.getElementById('services')?.scrollIntoView({behavior: 'smooth'}), 150);
    }
  };

  const links = (
    <>
      <button onClick={goToServices} className="site-link text-left font-semibold">Services</button>
      <Link to="/results" onClick={() => setOpen(false)} className="site-link font-semibold">Results</Link>
      <Link to="/pricing" onClick={() => setOpen(false)} className="site-link font-semibold">Pricing</Link>
    </>
  );

  return (
    <header className="site-header fixed inset-x-0 top-0 z-50">
      <nav className="max-w-7xl mx-auto h-20 px-4 sm:px-6 lg:px-8 flex items-center justify-between" aria-label="Main navigation">
        <Link to="/home" onClick={() => { setOpen(false); window.scrollTo(0, 0); }} aria-label="Jelly Local home">
          <Logo />
        </Link>
        <div className="hidden md:flex items-center gap-8 lg:gap-10 text-sm">{links}</div>
        <Link to="/pricing" className="site-button hidden md:inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-bold">
          See the plan <SafeIcon icon={FiArrowUpRight} />
        </Link>
        <button type="button" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} onClick={() => setOpen(!open)} className="md:hidden text-white p-2">
          <SafeIcon icon={open ? FiX : FiMenu} className="h-6 w-6" />
        </button>
      </nav>
      <AnimatePresence>
        {open && (
          <motion.div initial={{opacity: 0, y: -12}} animate={{opacity: 1, y: 0}} exit={{opacity: 0, y: -12}} className="md:hidden absolute top-20 inset-x-0 bg-[#0b1423] border-b border-white/10 px-6 py-8 shadow-2xl">
            <div className="flex flex-col gap-7 text-xl">{links}</div>
            <Link to="/pricing" onClick={() => setOpen(false)} className="site-button flex justify-center items-center gap-2 rounded-xl px-6 py-4 mt-8 font-bold">
              See the plan <SafeIcon icon={FiArrowUpRight} />
            </Link>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}